<div class="vat-number-check">

  <div class="vat-number-check__form-error fn-form-error-alert" [mmTestTarget]="'form-alert'"></div>

  <form #form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <div *ngIf="(currentCountry === 'nl' || currentCountry === 'fr')" class="vat-number-check__info-text">
      {{ 'PAGES.AUTH.REGISTRATION.CHECK_KVK.INFO_TEXT' | translate }}
    </div>

    <div class="vat-number-form__sections">
      <div class="vat-number-form__fields">
        <div class="vat-number-form__field">
          <label class="input-label">{{ config.label | translate }} *</label>

          <div class="vat-number row">
            <div class="input-group prefix">
              <span class="vat-number-prefix notranslate" *ngIf="vatPrefix!= ''">{{vatPrefix}}</span>
              <input name="{{config.name}}"
                     formControlName="{{config.name}}"
                     placeholder="{{ config.placeholder | translate }}"
                     test-target="input-vat-number"
                     [appNoSpaces]="config.noSpaces" />
            </div>
          </div>

          <mm-error
            *ngIf="formGroup.controls[config.name].touched && formGroup.controls[config.name].invalid"
            [fieldName]="config.name" class="vat-number-form__error"
            [mmTestTarget]="'input-error-' + config.name">
            {{ formGroup.controls[config.name].errors | errorMessage: config.name }}
          </mm-error>

          <div class="vat-number-check__mandatory-note">
            * {{ 'REGULAR.MANDATORY_FIELD' | translate }}
          </div>

        </div>
      </div>

      <div class="vat-number-form__actions">
        <button class="vat-number-form__action"
                type="submit"
                mm-button
                fluid="true"
                test-target="vat-number-form__submit"
                [loading]="isSubmitting">
          <div class="button-container">
            <div>{{ config.submitText | translate }}</div>
          </div>
        </button>
      </div>

    </div>
  </form>
</div>
